export default __webpack_public_path__ + "static/simple-bar-81bb46975a57ee113ca9a1683ecff36d.png";